import { render, staticRenderFns } from "./courseItem.vue?vue&type=template&id=1cdd8cc8&scoped=true&"
import script from "./courseItem.vue?vue&type=script&lang=js&"
export * from "./courseItem.vue?vue&type=script&lang=js&"
import style0 from "./courseItem.vue?vue&type=style&index=0&id=1cdd8cc8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdd8cc8",
  null
  
)

export default component.exports